import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initializePractice } from '../services/api';
import { RootState } from '../redux/store';
import { initFailure, initSuccess, startInit } from '../redux/slices/authSlice';

export function useInitPractice() {
  const dispatch = useDispatch();
  const { token, practice, loading, error } = useSelector((s: RootState) => s.auth);

  const init = useCallback(async (practiceId: string) => {
    dispatch(startInit());
    try {
      const result = await initializePractice(practiceId);
      dispatch(initSuccess({ token: result.token, practice: result.practice }));
      return result;
    } catch (e: any) {
      dispatch(initFailure(e?.message || 'Initialization failed'));
      throw e;
    }
  }, [dispatch]);

  return { token, practice, loading, error, init };
}